import { NgModule } from '@angular/core';
import { FreelancerHttpModule } from '@freelancer/freelancer-http';
import { BidAwardRevokeReasonService } from './bid-award-revoke-reason-service.service';

@NgModule({
  imports: [FreelancerHttpModule],
  providers: [BidAwardRevokeReasonService],
})
export class BidAwardRevokeReasonServiceModule {}
